import React, { useEffect, useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

// Update the path to the logo
const Logo = '/assests/JN_F_Logo.png'; // Corrected the path

function Header() {
    const [currentDate, setCurrentDate] = useState(new Date());
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Detect small screen size

    // Update the time every second
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentDate(new Date());
        }, 1000); // Update every second

        return () => clearInterval(intervalId); // Clean up the interval on component unmount
    }, []);

    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const monthsOfYear = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const dayOfWeek = daysOfWeek[currentDate.getDay()];
    const dayOfMonth = currentDate.getDate();
    const month = monthsOfYear[currentDate.getMonth()];
    const year = currentDate.getFullYear();
    const time = currentDate.toLocaleTimeString();

    const ordinalSuffix = (day) => {
      if (day > 3 && day < 21) return 'th'; // 11th, 12th, 13th, etc.
      switch (day % 10) {
        case 1:  return 'st';
        case 2:  return 'nd';
        case 3:  return 'rd';
        default: return 'th';
      }
    };

    const formattedDate = `${dayOfWeek} ${dayOfMonth}${ordinalSuffix(dayOfMonth)}, ${month} ${year} ${time}`;

    return (
        <Box
            sx={{
                 backgroundColor: '#fff', //backgroundColor: '#064EB4',
                padding: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                boxShadow: '0px 0px 0px rgba(0, 0, 0, 0)',
                flexDirection: isSmallScreen ? 'column' : 'row', // Stack vertically on small screens
                textAlign: isSmallScreen ? 'center' : 'center', // Center text on small screens
            }}
        >
            {/* Logo */}
            <Box sx={{ mb: isSmallScreen ? 1 : 0 }}>
                <img 
                    src={Logo} 
                    alt="NHF Logo" 
                    style={{ height: isSmallScreen ? 60 : 100, width: isSmallScreen ? 80 : 200 }} // Adjust size for smaller screens
                />
            </Box>

            {/* Title */}
            <Typography
                variant={isSmallScreen ? "h5" : "h2"} // Adjust font size for smaller screens
                sx={{
                    fontWeight: 'bold',
                    color: '#000',
                    fontFamily: 'Arial, sans-serif',
                    flexGrow: 1,
                }}
            >
                JN Group
            </Typography>

            {/* Time */}
            <Box sx={{ display: 'flex', alignItems: 'center', mt: isSmallScreen ? 1 : 0 }}>
                <AccessTimeIcon sx={{ color: '#000' }} />
                <Typography sx={{ marginLeft: 1, color: '#000' }}>
                    {formattedDate}
                </Typography>
            </Box>
        </Box>
    );
}

export default Header;
